function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { formatRewardScore } from './utils';
import styles from './styles.module.scss';
import icgTHCBattle from 'assets/img/ic_gthc_battles_v2.png';
import icDailygTHCBattle from 'assets/img/ic_daily_gthc_battles_v2.png';
import icCoinBonus from 'assets/img/thetan_coin_bonus_v2.png';
import icThetanCoin from 'assets/img/thetan_coin_V2.png';
import classNames from 'classnames';
import ReactTooltip from 'src/Components/TooltipProviderV2/ReactTooltip';
import { TooltipPosition } from 'src/Components/TooltipProviderV2';
import { generateBattleStyleColor } from 'src/Pages/MarketplaceV2/Components/MarketHero/Components/SearchResult/ItemCard/utils';
import { HeroStatus } from 'src/utils/types';
import { useTestId } from '@wolffun/testable-id';

const P2EPanel = ({
  item,
  reward
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const battleColor = generateBattleStyleColor(item.hero.totalBattleCapTHC - item.hero.battleCapTHC, item.hero.totalBattleCapTHC);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.p2eInfo
  }, /*#__PURE__*/React.createElement(ReactTooltip, {
    content: /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tooltipDesc, styles.tooltipMobile)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.description
    }, "Basic battle rewards for NFT heroes")),
    className: styles.tooltipWrap,
    position: TooltipPosition.TOP
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.item, styles.battleReward)
  }, generateTestIdProps('battle-rewards')), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icThetanCoin
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Basic Battle Rewards:"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapValue
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rowValue
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Win :"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatRewardScore(reward.win))), /*#__PURE__*/React.createElement("div", {
    className: styles.line
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rowValue
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Draw :"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatRewardScore(reward.draw))), /*#__PURE__*/React.createElement("div", {
    className: styles.line
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rowValue
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Lose :"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatRewardScore(reward.lose)))))), /*#__PURE__*/React.createElement(ReactTooltip, {
    content: /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tooltipDesc, styles.tooltipMobile)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.description
    }, "THC bonus earned for each won battle. Win bonus increases with higher hero levels")),
    position: TooltipPosition.TOP
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.item)
  }, generateTestIdProps('win-bonus')), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icCoinBonus
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Win Bonus"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapValueItem
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.valueItem
  }, item.hero.status === HeroStatus.DEFAULT ? 'NONE' : item.hero.thcBonus)))), /*#__PURE__*/React.createElement(ReactTooltip, {
    content: /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tooltipDesc, styles.tooltipMobile)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.description
    }, "Remaining battles eligible for earning THC:", ' ', item.hero.status === HeroStatus.DEFAULT ? 'NONE' : item.hero.totalBattleCapTHC - item.hero.battleCapTHC)),
    position: TooltipPosition.TOP
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.item)
  }, generateTestIdProps('gTHC-battles')), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icgTHCBattle
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "THC Battles"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapValueItem
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.valueItem, styles[battleColor])
  }, item.hero.status === HeroStatus.DEFAULT ? 'NONE' : `${item.hero.battleCapTHC}/${item.hero.totalBattleCapTHC}`)))), /*#__PURE__*/React.createElement(ReactTooltip, {
    content: /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tooltipDesc, styles.tooltipMobile)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.description
    }, "Total battles eligible for earning THC in a day")),
    position: TooltipPosition.TOP
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.item)
  }, generateTestIdProps('daily-gTHC-battles')), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icDailygTHCBattle
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Daily THC Battles"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapValueItem
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.valueItem
  }, item.hero.status === HeroStatus.DEFAULT ? 'NONE' : item.hero.dailyTHCBattleConfig))))));
};

export default P2EPanel;